import {
    showTheError,
    removeLocalStorage,
    saveLocalStorage,
    signup,
    login,
    loginWithSocialMedia,
    loginWithGoogleAfterVerifyEmail,
    replaceUserDataOnLocalStorage,
    verifyEmail,
    resendVerificationLink,
    setPassword
} from '../../../services/AuthService.js';

export default {
    async signup(context, payload) {
        const response = await signup(payload);
        const loginPayload = { token: response.token, user: response.data.user };
        await context.dispatch('auth/_saveUserPostLogin', loginPayload, { root: true });
    },
    async login(context, payload) {
        const response = await login(payload);
        const result = await context.dispatch('auth/_saveUserPostLogin', response, { root: true });
        return result;
    },
    async loginWithGoogle(context, payload) {
        try {
            const responseBack = await loginWithSocialMedia(payload.tokenGoogle);
            if (!responseBack.success) {
                showTheError(responseBack.message);
                return;
            }
            const result = await context.dispatch('auth/_saveUserPostLogin', responseBack.data, { root: true });
            return result;
        } catch (err) {
            showTheError(err);
        }
    },
    loginWithApple(context, payload) {
        console.log(context, payload);
    },
    logOut(context) {
        removeLocalStorage();
        context.commit('setUser', {
            token: null,
            currentUser: null
        });
        context.dispatch('school/removeInfoSchool', null, {root: true});
    },
    async checkAuthLocalStorage(context) {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');

        if (token && user) {
            context.commit('setUser', {
                token,
                user: JSON.parse(user)
            });
            if (context.getters.isOwner || context.getters.isAssistant) {
                await context.dispatch('auth/_postLoginSchoolFlow', token, { root: true });
            }
        }
    },
    saveDataUserAfterUpdateProfile(context, payload) {
        try {
            replaceUserDataOnLocalStorage(payload.user);
            context.commit('setCurrentUserAfterUpdateProfile', payload.user);
        } catch (err) {
            showTheError(err);
        }
    },
    async verifyEmail(context, payload) {
        const response = await verifyEmail(payload.token, payload.email);
        context.commit('setUserVerified', response.data.user.email);
    },
    async resendVerificationLink(context, payload) {
        const response = await resendVerificationLink(payload.email);
    },
    async setPassword(context, payload) {
        const response = await setPassword(payload.email, payload.password, payload.confirmPassword);
        await context.dispatch('auth/_saveUserPostLogin', response.data, { root: true });
    },
    async _saveUserPostLogin(context, response) {
        context.commit('setUser', response);
        saveLocalStorage(response);
        if (context.getters.isOwner || context.getters.isAssistant) {
            return await context.dispatch('auth/_postLoginSchoolFlow', response.token, { root: true });
        }
        return { needsSchoolChoice: false };
    },
    /** For owner/assistant: load my schools, set current or return needsSchoolChoice. */
    async _postLoginSchoolFlow(context, token) {
        try {
            const schools = await context.dispatch('school/loadMySchools', {}, { root: true });
            if (!schools || schools.length === 0) {
                await context.dispatch('school/getInfoSchool', { token }, { root: true });
                return { needsSchoolChoice: false };
            }
            if (schools.length === 1) {
                await context.dispatch('school/setCurrentSchool', schools[0]._id, { root: true });
                return { needsSchoolChoice: false };
            }
            const { getCurrentSchoolIdFromStorage } = await import('../../../services/SchoolService.js');
            const storedId = getCurrentSchoolIdFromStorage();
            const found = schools.find(s => s._id === storedId);
            if (found) {
                await context.dispatch('school/setCurrentSchool', storedId, { root: true });
                return { needsSchoolChoice: false };
            }
            const { setCurrentSchoolIdInStorage } = await import('../../../services/SchoolService.js');
            setCurrentSchoolIdInStorage(null);
            localStorage.removeItem('school');
            context.commit('school/setInfoSchool', { infoSchool: null }, { root: true });
            context.commit('school/setCurrentSchoolId', null, { root: true });
            return { needsSchoolChoice: true };
        } catch (err) {
            await context.dispatch('school/getInfoSchool', { token }, { root: true });
            return { needsSchoolChoice: false };
        }
    },
    cleanUserVerified(context) {
        context.commit('setUserVerified', null);
    },
    async loginWithGoogleAfterVerifyEmail(context, payload) {
        const response = await loginWithGoogleAfterVerifyEmail(payload.email, payload.tokenGoogle);
        if (!response.success) {
            showTheError(response.message);
        }
        await context.dispatch('auth/_saveUserPostLogin', response.data, { root: true });
    },
};